import type { RootState } from "@/app/store";

export const selectNativePrice = (state: RootState) =>
  state.tokenPrices.nativePrice;
export const selectMafiaPrice = (state: RootState) =>
  state.tokenPrices.mafiaPrice;